import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { CmsPageGuard, PageComponentModule } from '@spartacus/storefront'
import { JobSearchFeatureModule } from '../job-search-components/job-search-feature.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: null as any,
        canActivate: [CmsPageGuard],
        data: {
          pageLabel: 'job_detail_page',
          cxRoute: 'jobs'
        },
        children: [
          {
            path: ':id',
            loadChildren: () => import('./job-search-detail/job-search-detail-page.module').then(m => m.JobSearchDetailPageModule)
          }
        ]
      },
    ]),
    PageComponentModule,
    JobSearchFeatureModule,
  ]
})
export class JobSearchPagesModule {
}
